import { CommentBubble } from "./comment-bubble";

export interface Comment {
  id: string;
  content: string;
  timestamp: Date | string;
  isOwn: boolean;
}

interface EntityCommentsProps {
  comments: Comment[];
  className?: string;
}

export function EntityComments({ comments, className }: EntityCommentsProps) {
  if (comments.length === 0) {
    return null;
  }

  return (
    <div className={className}>
      <div className="flex flex-col gap-2">
        {comments.map((comment) => (
          <CommentBubble
            key={comment.id}
            content={comment.content}
            timestamp={comment.timestamp}
            isOwn={comment.isOwn}
          />
        ))}
      </div>
    </div>
  );
}
